// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.object-card {
  display: flex;
  flex-direction: column;
  width: 380px;
  height: 80vh;
  min-height: 500px;
  overflow-y: auto;
}

  .object-card .ant-tabs-content-holder {
    overflow-y: auto;
    margin-bottom: 1em;
  }

  .object-card .route-error {
    margin: 0 10px;
  }

.object-card-status {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px;
  justify-content: center;
  align-items: center;
}

.card-header-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  background-color: #f6f9fb;
}
.card-header-carousel-wrapper {
  position: 'relative';
  width: 380px;
  height: 273px;
}

.card-header-record-name {
  font-family: Golos;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.card-header {
  width: 100%;
  font-family: Golos;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #34373e;
}
.card-header p {
    margin: 10px;
  }

.card-control-button {
  display: flex;
  height: 52px;
  flex-direction: row;
  flex-shrink: 0;
  align-items: center;
  padding: 0 16px;
}

.card-control-button button {
    padding: 2px 0 0 0;
    width: 32px;
    height: 32px;
    margin-right: 15px;
  }

.card-field-item-description,
.card-field-item-value,
.card-files-item-name {
  font-size: 14px;
  line-height: 20px;
}

.card-field-item-description,
.card-link-item-description {
  color: #192033;
  font-weight: 600;
}

.card-field-item-value,
.card-files-item-name {
  color: #34373e;
}

.card-field-item {
  margin-bottom: 24px;
}

.slide-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f6f9fb;
}

.slide-img {
  -o-object-fit: cover;
     object-fit: cover;
}

.slide-status {
  position: absolute;
  bottom: 5px;
  left: 5px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
}

.slick-button {
  position: absolute;
  top: 150px;
  background-color: #ffffff;
  opacity: 0.6;
}

.ref-table-display {
  padding: 10px;
  display: flex;
}

.ref-table-display-pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.ref-table-loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.view-ref-table-button {
  width: 100%;
}

.ref-table-container {
  padding: 8px 16px;
}

.card-route-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Module/RecordCard/style.scss"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAUlB;;EARE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;AAGF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,yBAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,kBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAIhB;AAHE;IACE,YAAY;EACd;;AAGF;EACE,aAAa;EACb,YAAmC;EACnC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;AAQjB;;AANE;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;AAGF;;;EAGE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,cAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,cAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAA8B;AAChC;;AAEA;EACE,oBAAiB;KAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["@import '../../../../assets/scss/variables.scss';\n\n.object-card {\n  display: flex;\n  flex-direction: column;\n  width: 380px;\n  height: 80vh;\n  min-height: 500px;\n  overflow-y: auto;\n\n  & .ant-tabs-content-holder {\n    overflow-y: auto;\n    margin-bottom: 1em;\n  }\n\n  & .route-error {\n    margin: 0 10px;\n  }\n}\n\n.object-card-status {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n  justify-content: center;\n  align-items: center;\n}\n\n.card-header-wrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  width: 100%;\n  background-color: $white-light;\n}\n.card-header-carousel-wrapper {\n  position: 'relative';\n  width: 380px;\n  height: 273px;\n}\n\n.card-header-record-name {\n  font-family: $font-main;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 10px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n.card-header {\n  width: 100%;\n  font-family: $font-main;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 20px;\n  color: #34373e;\n  p {\n    margin: 10px;\n  }\n}\n\n.card-control-button {\n  display: flex;\n  height: $card-control-button-height;\n  flex-direction: row;\n  flex-shrink: 0;\n  align-items: center;\n  padding: 0 16px;\n\n  button {\n    padding: 2px 0 0 0;\n    width: 32px;\n    height: 32px;\n    margin-right: 15px;\n  }\n}\n\n.card-field-item-description,\n.card-field-item-value,\n.card-files-item-name {\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.card-field-item-description,\n.card-link-item-description {\n  color: $black-accent;\n  font-weight: 600;\n}\n\n.card-field-item-value,\n.card-files-item-name {\n  color: $black-primary;\n}\n\n.card-field-item {\n  margin-bottom: 24px;\n}\n\n.slide-wrapper {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: $white-light;\n}\n\n.slide-img {\n  object-fit: cover;\n}\n\n.slide-status {\n  position: absolute;\n  bottom: 5px;\n  left: 5px;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n}\n\n.slick-button {\n  position: absolute;\n  top: 150px;\n  background-color: $white;\n  opacity: 0.6;\n}\n\n.ref-table-display {\n  padding: 10px;\n  display: flex;\n}\n\n.ref-table-display-pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.ref-table-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.view-ref-table-button {\n  width: 100%;\n}\n\n.ref-table-container {\n  padding: 8px 16px;\n}\n\n.card-route-panel {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
